import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import AirtimeDataProducts from "../components/AirtimeDataProducts";

const AirtimeDataPage = () => {
  const navigate = useNavigate();
  const { walletBalances, fetchBalance } = useOutletContext();

  const handleBack = () => {
    navigate("/dashboard");
    // Refresh balance when returning from products
    fetchBalance();
  };

  return (
    <AirtimeDataProducts
      onBack={handleBack}
      walletBalances={walletBalances}
      onBalanceUpdate={fetchBalance}
    />
  );
};

export default AirtimeDataPage;
